module.exports = __webpack_public_path__ + "img/03-01.4f312e83.png";